<template>
	<div class="w-full h-full">
		<template v-if="pageType==='back'">
			<van-nav-bar left-text="返回" left-arrow @click-left="back" />
		</template>
		<div class="w-full h-full group">
			<!-- <div class="w-full group-top">
				<div class="layout-side group-top-top">
					<div class="group-top-top-item">
						<div class="w-full layout-center group-top-top-item-title">注册用户</div>
						<div class="w-full layout-center group-top-top-item-content">
							<div class="group-top-top-item-content-l" style="color: #FF8000">
								{{ groupInfo.registerNumber }}
							</div>
							<div class="group-top-top-item-content-r">人</div>
						</div>
					</div>
					<div class="group-top-top-item"
						style="border-left: var(--base-px-1) solid #D5D5D5;border-right: var(--base-px-1) solid #D5D5D5;">
						<div class="w-full layout-center group-top-top-item-title">昨日新增</div>
						<div class="w-full layout-center group-top-top-item-content">
							<div class="group-top-top-item-content-l" style="color: #62D64B">{{
									groupInfo.yesterdayAddRegister
								}}
							</div>
							<div class="group-top-top-item-content-r">人</div>
						</div>
					</div>
					<div class="group-top-top-item">
						<div class="w-full layout-center group-top-top-item-title">今日新增</div>
						<div class="w-full layout-center group-top-top-item-content">
							<div class="group-top-top-item-content-l" style="color: #F4AB3C">
								{{ groupInfo.dayAddRegister }}
							</div>
							<div class="group-top-top-item-content-r">人</div>
						</div>
					</div>
				</div>
				<div class="layout-center group-top-bottom">
					<div class="group-top-bottom-item">
						<div class="w-full layout-center group-top-bottom-item-title">今日会员奖励</div>
						<div class="w-full layout-center group-top-bottom-item-content">
							<div class="group-top-bottom-item-content-l" style="color: #FB4E4E">
								{{ groupInfo.dayUserRedCount }}
							</div>
							<div class="group-top-bottom-item-content-r">个</div>
						</div>
					</div>
					<div class="group-top-bottom-item" style="border-left: var(--base-px-1) solid #D5D5D5;">
						<div class="w-full layout-center group-top-bottom-item-title">今日会员奖励</div>
						<div class="w-full layout-center group-top-bottom-item-content">
							<div class="group-top-bottom-item-content-l" style="color: #5D83FF">
								{{ groupInfo.dayUserRedMoney }}
							</div>
							<div class="group-top-bottom-item-content-r">元</div>
						</div>
					</div>
				</div>
			</div> -->
			<div class="pagecard">
				<div class="pagecard-item" >
					<div class="">观看人数</div>
					<div class="name">{{info.watchNumber}}</div>
				</div>
				<div class="pagecard-item" >
					<div class="">完播人数</div>
					<div class="name">{{info.finishedNumber}}</div>
				</div>
				<div class="pagecard-item" >
					<div class="">完播率</div>
					<div class="name">{{info.finishedRate}}%</div>
				</div>

				<div class="pagecard-item" >
					<div class="">考核人数</div>
					<div class="name">{{info.rewardNumber}}</div>
				</div>
				<div class="pagecard-item" >
					<div class="">答题人数</div>
					<div class="name">{{info.questionNumber}}</div>
				</div>
				<div class="pagecard-item" >
					<div class="">正确人数</div>
					<div class="name">{{info.correctNumber}}</div>
				</div>
				<div class="pagecard-item" >
					<div class="">正确率</div>
					<div class="name">{{info.correctRate}}%</div>
				</div>
				<div class="pagecard-item" >
					<div class="">考核金额</div>
					<div class="name">{{info.rewardMoney}}</div>
				</div>

			</div>

			<div class="group-area">
				<div class="w-full group-center layout-side">
					<div class="group-center-button layout-center" @click="onActivated(0)"
						:class="[activeKey===0?'group-center-button-selected':'']">今日课程{{ activeKey===0?`（${listCount}）`:'' }}
					</div>
					<div class="group-center-button layout-center" @click="onActivated(2)"
						:class="[activeKey===2?'group-center-button-selected':'']">直播计划{{ activeKey===2?`（${listCount}）`:'' }}
					</div>
					<div class="group-center-button layout-center" @click="onActivated(1)"
						:class="[activeKey===1?'group-center-button-selected':'']">往日课程{{ activeKey===1?`（${listCount}）`:'' }}
					</div>
				</div>
				<div class="w-full group-content">
					<div class="group-content-dis">
						<div class="group-content-dis-t" @click="showPopup()">营期选择 -
							{{selectTrain==null?"全部":selectTrain.train_name}}
						</div>
						<div class="group-content-dis-f" v-show="activeKey===2">
							<div class="group-content-dis-f-item" :class="[typeTime==1?'group-content-dis-f-active':'']"
								@click="updateTime(1)">明日</div>
							<div class="group-content-dis-f-item" :class="[typeTime==2?'group-content-dis-f-active':'']"
								@click="updateTime(2)">后天</div>
							<div class="group-content-dis-f-item" :class="[typeTime==3?'group-content-dis-f-active':'']"
								@click="updateTime(3)">{{(formattedDate&&typeTime==3)?formattedDate:'自定义'}}</div>
						</div>
						<div class="group-content-dis-f" v-show="activeKey===1">
							<div class="group-content-dis-f-item" :class="[typeTime==-1?'group-content-dis-f-active':'']"
								@click="updateTime(-1)">昨日</div>
							<div class="group-content-dis-f-item" :class="[typeTime==-2?'group-content-dis-f-active':'']"
								@click="updateTime(-2)">前天</div>
							<div class="group-content-dis-f-item" :class="[typeTime==3?'group-content-dis-f-active':'']"
								@click="updateTime(3)">{{(formattedDate&&typeTime==3)?formattedDate:'自定义'}}</div>
						</div>
					</div>
					<div style=""  v-for="(campPeriod,index) in campPerlist" :key="index">
						<div class="w-full group-content-card" v-if="campPeriod.lesson_title">
							<div class="group-content-card-c layout-side">
								<div class="group-content-card-c-l">
									<img alt="" :src="campPeriod.video_image" class="w-full h-full">
								</div>
								<div class="group-content-card-c-r">
									<div class="group-content-card-c-r-t">
										<div class="group-content-card-c-r-t-title">{{ campPeriod.lesson_title }}</div>
										<div v-show="activeKey!=2" class="group-content-card-c-r-t-number" style="white-space:nowrap;"
											@click.stop="onData(campPeriod)">
											数据统计>
										</div>
									</div>
									<div class="group-content-card-c-r-c">营期：{{ campPeriod.train_name }}</div>
									<div class="group-content-card-c-r-b layout-side">
										<div>时长：{{ campPeriod.times }}</div>
<!--										<div v-if="activeKey!=1 && !userDatalt.isDealer" class="layout-right-center"
											@click="onShare(campPeriod)" style="font-size: var(&#45;&#45;base-px-12);color: #1A89F9">
											<img style="width: var(&#45;&#45;base-px-10);height: var(&#45;&#45;base-px-10);margin-right: var(&#45;&#45;base-px-2)"
												src="../../assets/course/2.png" />分享
										</div>-->
									</div>
								</div>
							</div>
							<div class="group-content-card-b layout-side">
								<div style="width: 25%">
									<div class="w-full layout-center b-t"
										style="height: var(--base-px-20);border-right: var(--base-px-1) solid #DBDBDB">
										观看人数
									</div>
									<div class="w-full layout-center b-b" style="margin-top: var(--base-px-3)">{{
											campPeriod.lessonWatchNumber
										}}
									</div>
								</div>
								<div style="width: 25%">
									<div class="w-full layout-center b-t"
										style="height: var(--base-px-20);border-right: var(--base-px-1) solid #DBDBDB">
										完播率
									</div>
									<div class="w-full layout-center b-b" style="margin-top: var(--base-px-3)">{{
											campPeriod.finishedRate
										}}
									</div>
								</div>
								<div style="width: 25%;">
									<div class="w-full layout-center b-t"
										style="height: var(--base-px-20);border-right: var(--base-px-1) solid #DBDBDB">
										答题人数
									</div>
									<div class="w-full layout-center b-b" style="margin-top: var(--base-px-3)">{{
											campPeriod.watchNumber
										}}
									</div>
								</div>
								<div style="width: 25%">
									<div class="w-full layout-center b-t" style="height: var(--base-px-20);">正确率</div>
									<div class="w-full layout-center b-b">{{ campPeriod.correctRate }}%</div>
								</div>
							</div>
						</div>

					</div>
					<div class="w-full layout-center" v-if="campPerlist.length==0">
						<van-empty class="custom-image" :image="require('../../assets/images/emptyimg.png')"
							description="暂无数据" />
					</div>
				</div>
			</div>

		</div>
		<div v-show="showShare" @click="onShareClose()" style="position: fixed;
    top: 0;
    left: 0;
    z-index: 98;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);">
		</div>
		<div v-show="showShare" style="height: 20%;
    border-radius: var(--base-px-16) var(--base-px-16) 0px 0px;
    z-index: 2002;    bottom: 0;
    left: 0;
    width: 100%;position: fixed;
    max-height: 100%;
    overflow-y: auto;
    background-color: #fff;transition: transform .3s,-webkit-transform .3s;">
			<div class="w-full "
				style="padding: var(--base-px-12);display: flex;justify-content: flex-start;align-items: center;">
				<div style="width: 25%;display: flex;align-items: center;flex-direction: column;"
					v-for="(item,index) in options" :key="'share_'+index" :id="'share'+index"
					:data-clipboard-text="item.url"
					@click="copy(item.url,'share'+index,item.title,item.image,item.miniAppId,item.pages)">
					<img style="width: var(--base-px-48);height: var(--base-px-48);" :src="item.icon" alt="" />
					<div class="layout-center"
						style="margin-top: var(--base-px-8);color: #646566;font-size: var(--base-px-12);">
						{{
							item.name
						}}
					</div>
				</div>
			</div>
		</div>
		<van-popup v-model="show" @clickOverlay="onDateCancel" position="bottom" class="group-p"
			:style="{ height: '60%' }">
			<!-- <div class="">
				选择时间
			</div> -->
			<div class="group-p-t layout-center" style="position: relative">
				营期选择
			</div>
			<div class="group-p-c w-full">
				<div class="group-p-c-c w-full h-full">
					<div class="group-p-c-c-t w-full layout-left-center" style="margin-bottom: var(--base-px-12)">营期
					</div>
					<div class="group-p-c-c-c">
						<div class="group-p-c-c-c-l   layout-side" v-for="(item,index) in campPeriods"
							:key="'cp_'+index"
							:style="{background: item.train_id===selectTrain?.train_id?'rgb(26, 137, 249)':''}"
							@click="onClickTrain(item)">
							<!-- <div class="group-p-c-c-c-l-l layout-center"
								:style="{color: item.train_id===selectTrain?.train_id?'#ffffff':''}">{{ item.sort }}
							</div> -->
							<div class="group-p-c-c-c-l-r layout-left-center"
								:style="{color: item.train_id===selectTrain?.train_id?'#ffffff':''}">
								{{ item.train_name }}
							</div>
						</div>
					</div>
				</div>
				<div class="w-full layout-side">
					<div class="layout-center" @click="onCancel"
						style="width: 45%;padding: var(--base-px-12) 0;font-weight: 500;font-size: var(--base-px-12);color: #666666;border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);border: var(--base-px-1) solid #CCCCCC;">
						取消
					</div>
					<div class="layout-center" @click="onOk"
						style="width: 45%;padding: var(--base-px-12) 0;background: #1A89F9;font-weight: 500;font-size: var(--base-px-12);color: #FFFFFF;border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);">
						确认
					</div>
				</div>
			</div>
		</van-popup>
		<van-popup v-model="showDate" position="bottom" class="group-d" :style="{ height: '53%' }">
			<van-datetime-picker v-model="currentDate" type="date" class="h-full" title="营期选择" :min-date="minDate"
				:max-date="maxDate" :visible-item-count="10" @cancel="onDateCancel" @confirm="onDateConfirm" />
		</van-popup>

		<IndexModel v-if="data_model" :data="data_model" :train_lesson_id="train_lesson_id"
			v-on:close="data_model = false"></IndexModel>
	</div>
</template>
<script>
	import IndexModel from "../my/indexModel.vue";
	import {
		trainLessonDataStatistics,
	} from "@/api/course"
	import {
		defineComponent,
		onActivated
	} from 'vue'
	import {
		groupManagerDetails,
		tenantVideoDataStatisticsLogic,
		groupManagerTrainList,
		groupManagerTrainCourseList
	} from '@/api/my'
	import {
		createCourseSharingLink
	} from "@/api/course";
	import wechatIcon from "../../assets/course/3.png";
	import miniIcon from "../../assets/course/4.png";
	import shareIcon from '../../assets/share-k.png'
	import Clipboard from "clipboard";
	import {
		userCenter
	} from "@/api/homePage";
	import {
		sendChatMessage,
		shareToExternalMoments
	} from "../../utils/wxCodeAuth";
	import {
		message
	} from "ant-design-vue";

	export default defineComponent({
		name: "group",
		components: {IndexModel},
		data() {
			return {
				listCount:0,
				pageType: '',
				campPerlist:[],
				campPeriod: {},
				campPeriods: [],
				activeKey: 0,
				show: false,
				showDate: false,
				groupInfo: {
					"registerNumber": 0,
					"contactNumber": 0,
					"dayAddRegister": 0,
					"dayAddContact": 0,
					"dayUserRedMoney": 0
				},
				minDate: new Date(2000, 0, 1),
				maxDate: new Date(2099, 10, 1),
				currentDate: new Date(),
				employeeId: '',
				formattedDate: '',
				selectTrain: null,
				userDatalt: {
					name: '',
                    isDealer:0
				},
				text: 'http://www.baidu.com&' + Math.round(Math.random() * 10),
				showShare: false,
				options: [{
						name: '分享链接',
						type: 1,
						icon: wechatIcon,
						url: ''
					},
					{
						name: '分享小程序',
						type: 2,
						icon: miniIcon,
						url: ''
					},
					{
						name: '分享卡片',
						type: 3,
						icon: shareIcon,
						url: ''
					},
					{
						name: '卡片群发',
						type: 4,
						icon: miniIcon,
						url: ''
					},
					{
						name: '欢迎语卡片',
						type: 5,
						icon: shareIcon,
						url: ''
					},
				],
				typeTime: null,
				data_model: false,
				train_lesson_id:null,
				info:{
					watchNumber: 0,
				    finishedNumber: 0,
				    finishedRate: 0,
				    questionNumber: 0,
				    correctNumber: 0,
				    correctRate: 0,
				    rewardNumber: 0,
				    rewardMoney: 0,
				}
			}
		},
		created() {
			const {
				id,
				type
			} = this.$route.query
			this.pageType = type
			this.employeeId = id
			userCenter().then(res => {
                if (res.code == 1) {
                    this.userDatalt = res.data
                }
			})
			// groupManagerDetails({
			// 	employeeId: this.employeeId
			// }).then(res => {
			// 	this.groupInfo = res.data
			// })
			this.onActivated(0)

		},
		methods: {
			getgroupManagerTrainCourseList(){
				groupManagerTrainCourseList({
					employeeId: this.employeeId,
					date: this.formattedDate,
					train_id: this.selectTrain?.train_id
				}).then(res => {
                    if (res.code == 1) {
                        this.campPerlist = res.data //后续直接赋值
                        this.listCount = res.data.length
                    }

					// this.campPerlist=[];
					// this.campPerlist.push(res.data);//为了多条效果
					// this.campPerlist.push(res.data);//为了多条效果
				})

				tenantVideoDataStatisticsLogic({
					employeeId: this.employeeId,
					date: this.formattedDate,
					train_id: this.selectTrain?.train_id
				}).then(res => {
                    if(res.code == 1) {
                        this.info = res.data
                    }

				})

			},
			// 添加 $show 方法供父组件调用
			$show() {
				this.showPopup();
			},
			back() {
				this.$router.back()
			},
			copy(url, id, title, image, miniAppId, pages) {
				if (id === 'share0') {
					message.error('暂不支持此分享方式');
					return;
				}
				if (id === 'share2') {
					let miniData = {}
					//走企业微信发送小程序卡片消息接口
					miniData.appid = miniAppId;
					miniData.title = title;
					miniData.imgUrl = image;
					miniData.page = pages;
					sendChatMessage(6, miniData).then(res => {
						this.$message.success('发送成功')
					})
					return;
				}
				if (id == 'share3') {
					this.$router.push({
						path: '/contactMessageBatchSend/create',
						query: {
							shareInfo: encodeURIComponent(JSON.stringify(this.options[3]))
						}
					})
					return;
				}
				if (id == 'share4') {
					this.$router.push({
						path: '/contactWelcome/create',
						query: {
							shareInfo: encodeURIComponent(JSON.stringify(this.options[4]))
						}
					})
					return;
				}
				const that = this
				this.text = url
				let clipBoard = new Clipboard(`#${id}`);
				clipBoard.on('success', function() {
					clipBoard.destroy(); //销毁上一次的复制内容
					clipBoard = new Clipboard(`#${id}`);
					that.$toast.success('复制成功');
				});
				clipBoard.on('error', function() {
					that.$dialog.confirm({
						title: '复制提示',
						message: `链接生成失败，请重新点击获取`,
						confirmButtonText: '我知道了'
					});
				})
			},
			onShareClose() {
				this.showShare = false
			},
			async onShare(item) {
				// createCourseSharingLink({
				// 	train_lesson_id: item.train_lesson_id,
				// 	validity_time: '100',
				// 	type: 1
				// }).then(one => {
				// 	this.options[0].url = one.data.url
				// })
				createCourseSharingLink({
					train_lesson_id: item.train_lesson_id,
					validity_time: '100',
					type: 2
				}).then(two => {
					this.options[1].url = two.data.url
				})
				createCourseSharingLink({
					train_lesson_id: item.train_lesson_id,
					validity_time: '100',
					type: 3
				}).then(two => {
					this.options[2].miniAppId = two.data.miniAppId
					this.options[2].pages = two.data.pages

					this.options[3].miniAppId = two.data.miniAppId
					this.options[3].pages = two.data.pages
					this.options[4].miniAppId = two.data.miniAppId
					this.options[4].pages = two.data.pages
				})

				this.options.forEach(e => {
					e.title = item.lesson_title
					e.image = item.video_image
				})
				setTimeout(() => {
					this.showShare = true
					this.showShare = false
					this.showShare = true
				}, 100)
			},
			onActivated(e) {
				 this.activeKey = e
				// if (e === 1) {
				// 	this.showDate = true
				// 	this.formattedDate = this.gettiem(0);
				// 	this.currentDate=new Date(this.formattedDate);
				// } else {
				// 	// groupManagerTrainCourseList({
				// 	// 	employeeId: this.employeeId,
				// 	// 	train_id: this.selectTrain?.train_id
				// 	// }).then(res => {
				// 	// 	this.campPeriod = res.data

				// 	// })
				// }
				let d  = 0
				if (this.activeKey === 2) {
					d = 1
				} else if (this.activeKey === 1) {
					d = -1
				}
				this.updateTime(d)
			},
			showPopup() {
				this.campPeriods = [{
					sort: '全部营期',
					train_id: null,
					train_name: '全部营期',
				}]
				if (!this.selectTrain) {
					this.selectTrain = this.campPeriods[0];
				}
				groupManagerTrainList({
					employeeId: this.employeeId
				}).then(res => {

					let i = 1;
					res.data.forEach(item => {
						this.campPeriods.push({
							...item,
							sort: `第${this.numberToChinese(i)}期`
						})
						i++
					})

					console.log(this.campPeriods);
					this.show = true
				})
			},
			numberToChinese(num) {
				// 定义中文数字数组
				const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];

				// 处理0-10的情况
				if (num >= 0 && num <= 10) {
					return chineseNumbers[num] || '十'; // 10需要特殊处理
				}

				// 处理11-99的情况
				const tens = Math.floor(num / 10); // 十位数
				const units = num % 10; // 个位数

				let result = '';

				// 十位部分 (10-19特殊处理为"十x")
				if (tens === 1) {
					result = '十';
				} else {
					result = chineseNumbers[tens] + '十';
				}

				// 个位部分 (如果个位不为0则添加)
				if (units !== 0) {
					result += chineseNumbers[units];
				}

				return result;
			},
			onClickTrain(item) {
				if (item.train_id === this.selectTrain?.train_id) {
					this.selectTrain = null
				} else {
					this.selectTrain = item
				}
			},
			onCancel() {
				this.show = false
			},
			onOk() {
				// groupManagerTrainCourseList({
				// 	employeeId: this.employeeId,
				// 	data: this.activeKey === 0 ? '' : this.formattedDate,
				// 	train_id: this.selectTrain?.train_id
				// }).then(res => {
				// 	this.campPeriod = res.data
				// 	this.show = false
				// })
				this.getgroupManagerTrainCourseList();
				this.show=false;
			},
			onDateCancel(e) {
				this.activeKey = 0
				this.showDate = false
			},
			onDateConfirm(e) {
				const date = this.currentDate;
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要加1
				const day = date.getDate().toString().padStart(2, '0');
				this.formattedDate = `${year}-${month}-${day}`
				this.showDate = false
				// groupManagerTrainCourseList({
				// 	employeeId: this.employeeId,
				// 	date: this.formattedDate,
				// 	train_id: this.selectTrain?.train_id
				// }).then(res => {
				// 	this.campPeriod = res.data
				// })
				this.getgroupManagerTrainCourseList();
			},
			gettiem(offset) {
				const date = new Date();
				date.setDate(date.getDate() + offset);

				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');

				return `${year}-${month}-${day}`;
			},
			updateTime(type) {
				this.typeTime = type;
				if (this.typeTime === 3) {
					const date = new Date();
					if(this.activeKey == 1) { //之前
						date.setDate(date.getDate() -1)
						this.maxDate = date
						this.minDate = new Date(2000, 0, 1)
					} else if (this.activeKey == 2) { //之后
						date.setDate(date.getDate() +1)
						this.minDate = date
						this.maxDate = new Date(2099, 10, 1)
					}
					this.showDate = true;
				} else {
					this.formattedDate = this.gettiem(this.typeTime);
					this.currentDate=new Date(this.formattedDate);
					console.log(this.formattedDate);
					// groupManagerTrainCourseList({
					// 	employeeId: this.employeeId,
					// 	date: this.formattedDate,
					// 	train_id: this.selectTrain?.train_id
					// }).then(res => {
					// 	this.campPeriod = res.data
					// })
					this.getgroupManagerTrainCourseList();
				}
			},
			//数据统计
			onData: function(data = false) {
				trainLessonDataStatistics({
					train_lesson_id: data.train_lesson_id
				}).then(r => {
					this.train_lesson_id = data.train_lesson_id;
					this.data_model = r.data;
				})


			},

		}
	})
</script>
<style lang="less">
	.group {
		background: #F7F8FC;
		padding: var(--base-px-16) var(--base-px-12);

		.van-empty__image {
			height: auto;

			img {
				width: 100%;
				height: auto;
			}
		}

		&-top {
			height: var(--base-px-147);
			background: #FFFFFF;
			border-radius: var(--base-px-12) var(--base-px-12) var(--base-px-12) var(--base-px-12);
			padding: var(--base-px-16) 0;

			&-top {

				&-item {
					width: 33.33%;
					height: var(--base-px-49);

					&-title {
						color: #333333;
						font-size: var(--base-px-12);
					}

					&-content {
						&-l {
							font-weight: bold;
							font-size: var(--base-px-20);
						}

						&-r {
							color: #333333;
							font-size: var(--base-px-12);
							padding: var(--base-px-5) 0 0 var(--base-px-1);
						}
					}
				}
			}

			&-bottom {
				margin-top: var(--base-px-25);
				height: var(--base-px-49);

				&-item {
					width: 50%;

					&-title {
						color: #333333;
						font-size: var(--base-px-12);
					}

					&-content {
						&-l {
							font-weight: bold;
							font-size: var(--base-px-20);
						}

						&-r {
							color: #333333;
							font-size: var(--base-px-12);
							padding: var(--base-px-5) 0 0 var(--base-px-1);
						}
					}
				}
			}
		}

		&-center {
			height: var(--base-px-41);
			margin-top: var(--base-px-16);

			&-button {
				height: var(--base-px-41);
				border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
				width: calc(35% - var(--base-px-16));
				font-weight: 500;
				font-size: var(--base-px-12);
				border: var(--base-px-1) solid #CCCCCC;
				color: #333333;

				&-selected {
					background: #1A89F9;
					color: #FFFFFF;
					border: var(--base-px-1) solid #1A89F9;
				}
			}
		}

		&-content {
			overflow: auto;
			margin-top: var(--base-px-23);

			&-dis {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: var(--base-px-19);

				&-t {
					font-family: Source Han Sans;
					color: #1A89F9;
					font-weight: 500;
					font-size: var(--base-px-16);
				}

				&-f {
					display: flex;
					justify-content: flex-start;
					align-items: center;

					&-item {
						font-family: Source Han Sans;
						font-size: var(--base-px-14);
						font-weight: 350;
						color: #333333;
						margin-right: var(--base-px-20);
					}

					&-active {
						font-family: Source Han Sans;
						font-size: var(--base-px-14);
						font-weight: 350;
						color: #1A89F9;
						margin-right: var(--base-px-20);
					}
				}
			}

			&-card {
				background: #FFFFFF;
				border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
				padding: var(--base-px-12);
				margin-bottom: var(--base-px-10) ;


				&-c {
					//margin-top: var(--base-px-12);

					&-l {
						width: var(--base-px-100);
						height: var(--base-px-57);
						background: #F56464;
						border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
					}

					&-r {
						padding-left: var(--base-px-12);
						width: calc(100% - var(--base-px-120));

						&-t {
							//height: var(--base-px-32);
							display: flex;
							justify-content: space-between;
							align-items: center;

							&-title {
								font-weight: bold;
								font-size: var(--base-px-14);
								color: #333333;
								//line-height: var(--base-px-16);
								text-align: left;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								/* 限制两行 */
								overflow: hidden;
							}

							&-number {
								font-family: Source Han Sans;
								font-size: var(--base-px-14);
								font-weight: 350;
								color: #1A89F9;
							}
						}

						&-c {
							margin-top: var(--base-px-11);
							//height: var(--base-px-32);
							font-weight: 500;
							font-size: var(--base-px-11);
							color: #333333;
							//line-height: var(--base-px-16);
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							/* 限制两行 */
							overflow: hidden;
						}

						&-b {
							margin-top: var(--base-px-11);
							//height: var(--base-px-17);
							font-weight: 400;
							font-size: var(--base-px-12);
							color: #333333;
							//line-height: var(--base-px-16);
						}
					}
				}

				&-b {
					margin-top: var(--base-px-16);
					padding: 0 var(--base-px-14);

					.b-t {
						font-weight: 500;
						font-size: var(--base-px-14);
						color: #333333;
					}

					.b-b {
						font-weight: bold;
						font-size: var(--base-px-14);
						color: #333333;
					}
				}
			}
		}

		&-p {
			padding: 0 var(--base-px-13);

			&-t {
				padding: var(--base-px-14) 0 var(--base-px-12) 0;
				font-weight: bold;
				font-size: var(--base-px-14);
				color: #333333;
				border-bottom: var(--base-px-1) solid #ECECEC;

				&-l {
					position: absolute;
					left: 0;
					font-weight: 400;
					font-size: var(--base-px-13);
					color: #666666;
				}
			}

			&-c {
				padding-top: var(--base-px-12);
				height: calc(100% - var(--base-px-124));

				&-c {
					overflow: auto;
					padding-bottom: var(--base-px-4);

					&-t {
						height: var(--base-px-20);
						font-weight: bold;
						font-size: var(--base-px-14);
						color: #333333;
					}

					&-c {
						display: flex;
						justify-content: flex-start;
						flex-wrap: wrap;
						align-items: center;

						&-l {
							padding: var(--base-px-8) var(--base-px-32);
							background: #F7F8FC;
							border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);
							margin-bottom: var(--base-px-10);
							margin-right: var(--base-px-28);

							&-l {
								font-weight: bold;
								font-size: var(--base-px-12);
								color: #333333;
								height: var(--base-px-34);
								width: var(--base-px-36);
							}

							&-r {
								//width: calc(100% - var(--base-px-36));
								// padding-left: var(--base-px-24);
								font-weight: 500;
								font-size: var(--base-px-12);
								color: #333333;
								height: var(--base-px-34);
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 2;
								/* 限制两行 */
								overflow: hidden;
							}
						}
					}
				}
			}
		}
	}

	.pagecard {
		border-radius: var(--base-px-12);
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		background-color: #FFFFFF;
		padding: var(--base-px-16) 0;

		.pagecard-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			font-family: Source Han Sans;
			font-size: var(--base-px-14);
			font-weight: 350;
			color: #1A89F9;
			width: 25%;
			border-right: 1px solid #D5D5D5;
			margin-bottom: var(--base-px-12);

			&:nth-of-type(4n) {
				border: none !important;
			}

			.name {
				margin-top: var(--base-px-10);
				font-family: Source Han Sans;
				font-size: var(--base-px-14);
				font-weight: 350;
				color: #333333;
			}
		}
	}
</style>
